import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import InsertItemForm from './InsertItemForm'
import SearchForItem from './SearchForItem'
import SelectCategoryForm from './SelectCategoryForm'

class AddItemForm extends PureComponent {
  state = {
    searching: true,
  }

  componentWillReceiveProps(nextProps) {
    // Reset searching flag when category changed
    if (nextProps.currentCategory !== this.props.currentCategory) {
      this.setState({ searching: true })
    }
  }

  renderCategorySection() {
    const {
      onSubmit,
      onSubmitSuccess,
      onSubmitOwned,
      onSubmitOwnedSuccess,
      currentCategory,
      searchCategories,
      interest,
    } = this.props

    const searchEnabled = searchCategories.indexOf(currentCategory.id) !== -1

    if (searchEnabled && this.state.searching) {
      return (
        <SearchForItem
          category={currentCategory}
          onSubmitOwned={onSubmitOwned}
          onSubmitOwnedSuccess={onSubmitOwnedSuccess}
          onDismiss={() => this.setState({ searching: false })}
        />
      )
    }

    return (
      <InsertItemForm
        interest={interest}
        onSubmit={onSubmit}
        onSubmitSuccess={onSubmitSuccess}
      />
    )
  }

  render() {
    const { currentCategory, style } = this.props
    return (
      <div style={style}>

        <SelectCategoryForm />

        {currentCategory && <div>{this.renderCategorySection()}</div>}

      </div>
    )
  }
}

AddItemForm.defaultProps = {
  searchCategories: [],
  interest: false,
}

const selector = formValueSelector('add-item-form')

const mapStateToProps = state => {
  const currentCategory = selector(state, 'category')

  return {
    currentCategory,
  }
}

export default connect(mapStateToProps)(AddItemForm)



// WEBPACK FOOTER //
// ./src/common/AddItemForm/AddItemForm.js